<AuthCard>
    <v-row>
        <v-col>
            <h1 class="text-black">Two Factor Authentication Setup</h1>
        </v-col>
    </v-row>
    <v-row>
        <v-col>
            <v-divider></v-divider>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="8">
            <p>
                The BMW International Feedback Management web application
                requires every user to set up two factor authentication.
                <br />
                <b>Use this QR Code</b>
                to set up a compatible authentication app of your choice to
                generate security codes for the login procedure.
            </p>
        </v-col>
        <v-col cols="4">
            <div class="d-flex justify-end">
                <img id="qrCode" src="" class="qr-code-img" />
            </div>
        </v-col>
    </v-row>
    <v-row>
        <v-col>
            <v-divider></v-divider>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="8">
            <p>
                Download an authenticator app from the app store for your
                device and use it to scan the QR code above.
            </p>
        </v-col>
        <v-col cols="4">
            <div class="d-flex justify-end">
                <img :src="appStoreLogo" class="store-logo" />
                <img :src="playStoreLogo" class="store-logo" />
            </div>
        </v-col>
    </v-row>
    <v-row>
        <v-col>
            <v-divider></v-divider>
        </v-col>
    </v-row>
    <v-row>
        <v-col>
            <p>
                After the app is set up, use it to generate a security code
                to confirm the activation.
            </p>
            <p>
                <b class="text-red">Attention</b>
                :
                <br />
                Please make sure that the clock on your mobile device is
                synchronized with the internet.
                <br />
                If the server and your device times don't match, the
                generated codes will be invalid.
            </p>
            <TwoFactorForm @submit="submit" :loading="loading" />
        </v-col>
    </v-row>
    <BaseDialog label="Error" :width="300" v-model="tokenErrorPopupVisible">
        <p>Token is invalid.</p>
        <v-btn color="primary" variant="flat" tile @click="goToLoginPage">
            Back to login
        </v-btn>
    </BaseDialog>
    <BaseDialog label="Success" :width="300" v-model="successPopupVisible">
        <p>Activation successful.</p>
        <v-btn color="primary" variant="flat" tile @click="onSuccess">
            Continue
        </v-btn>
    </BaseDialog>
</AuthCard>